import { ReportListItemData } from './report-base';

export class RemovedBallanceUserListItem extends ReportListItemData {
  date: Date;
  removedBy: string;
  reason: string;
  amount: number;
  fee: string;

  get exportData() {
    return {
      Members: `${this.firstName} ${this.lastName}`,
      Team: this.teamGroup,
      Date: new Date(this.date).toISOString().slice(0, 10),
      Gender: this.gender.toLowerCase() === 'f' ? 'Female' : this.gender.toLowerCase() === 'm' ? 'Male' : this.gender,
      Fee: this.fee,
      By: this.removedBy,
      Reason: this.reason,
      Amount: this.amount
    };
  }
}

export class RemovedBallanceReport {
  removedPlayers: number;
  removedAmount: number;
  list: RemovedBallanceUserListItem[];

  constructor(data: any = {}) {
    this.removedPlayers = +data.removedPlayers;
    this.removedAmount = +data.removedAmount;
    this.list = data.list ? data.list.map(l => new RemovedBallanceUserListItem(l)) : [];
  }
}



// WEBPACK FOOTER //
// ./src/app/models/reports/removed-ballances-report.ts